export default __webpack_public_path__ + "static/media/GM.e62555c2.svg";